// extracted by mini-css-extract-plugin
export default {"searchInput":"SearchChat_searchInput__alCx8","searchIcon":"SearchChat_searchIcon__+T-Ix","searchInputWrapper":"SearchChat_searchInputWrapper__1bttR"};